module.exports = __webpack_public_path__ + "img/image80.d8692601.jpg";